import { MarketplaceLocationsWrapper } from '../../components'

export default function MarketplaceLocationsPage() {
  return <MarketplaceLocationsWrapper />
}
